import React from "react";
import { Helmet } from "react-helmet-async";
import "./TermsAndConditions.css";

const TermsAndConditions = () => {
  const lastUpdated = "March 2026";
  const domain = "shreeramcarrental.com"; // Updated to .com

  // Breadcrumb Schema for SEO
  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": `https://${domain}`
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "Terms and Conditions",
        "item": `https://${domain}/terms-and-conditions`
      }
    ]
  };

  return (
    <main className="terms-container">
      <Helmet>
        <title>Terms and Conditions | Shree Ram Car Rental Indore</title>
        <meta name="description" content="Read the official terms and conditions for Shree Ram Car Rental Indore. Information on vehicle responsibility, fuel policy, and rental agreements." />
        <link rel="canonical" href={`https://${domain}/terms-and-conditions`} />
        <script type="application/ld+json">
          {JSON.stringify(breadcrumbSchema)}
        </script>
      </Helmet>

      <section className="terms-section">
        <header className="terms-header">
          <div className="icon-shield" aria-hidden="true">🛡️</div>
          <h1>Terms of Service</h1>
          <p className="last-updated">Last Updated: {lastUpdated}</p>
        </header>

        <div className="terms-wrapper">
          <article className="terms-card">
            <div className="terms-intro">
              <p>
                Welcome to <strong>Shree Ram Car Rental</strong>. By booking our services, 
                you enter into a legal agreement. Please review our policies regarding 
                vehicle safety, maintenance, and conduct.
              </p>
            </div>

            <div className="terms-grid">
              <section className="terms-item">
                <span className="step-num">01</span>
                <h3>Vehicle Responsibility</h3>
                <p>
                  The customer is the temporary custodian of the vehicle. Any internal 
                  or external damage caused by negligence or accidents during the 
                  rental period is the <strong>financial responsibility of the customer</strong>.
                </p>
              </section>

              <section className="terms-item highlighted-rule">
                <span className="step-num">02</span>
                <h3>Authorized Repairs Only</h3>
                <p>
                  In the event of any damage, repairs must be performed <strong>ONLY at an Authorized Service Center</strong> 
                  (Showroom). Unauthorized local workshop repairs are strictly prohibited to 
                  maintain vehicle safety and manufacturer warranty.
                </p>
              </section>

              <section className="terms-item">
                <span className="step-num">03</span>
                <h3>Fuel & Energy Policy</h3>
                <p>
                  Vehicles are provided with a specific fuel level. Customers must 
                  return the car at the <strong>same level</strong>. Shortfalls are 
                  billed at current market rates plus a convenience fee.
                </p>
              </section>

              <section className="terms-item">
                <span className="step-num">04</span>
                <h3>Legal & Traffic Compliance</h3>
                <p>
                  The hirer is liable for all <strong>traffic violations, overspeeding fines (Challans),</strong> 
                  and illegal parking penalties incurred during the rental period.
                </p>
              </section>

              <section className="terms-item">
                <span className="step-num">05</span>
                <h3>Booking & Cancellations</h3>
                <p>
                  Booking is confirmed only after a partial advance payment. 
                  Cancellations made within 24 hours of the trip start time may 
                  incur a <strong>cancellation fee</strong>.
                </p>
              </section>

              <section className="terms-item">
                <span className="step-num">06</span>
                <h3>Outstation Logistics</h3>
                <p>
                  For multi-day outstation trips, the customer is responsible for 
                  providing standard <strong>Driver Allowance (DA)</strong>, covering 
                  basic meals and safe overnight accommodation for the driver.
                </p>
              </section>
            </div>

            <footer className="terms-footer">
              <p>By proceeding with the booking, you acknowledge these terms in full.</p>
              <button 
                className="print-btn" 
                onClick={() => window.print()}
                aria-label="Print terms and conditions"
              >
                🖨️ Print for Records
              </button>
            </footer>
          </article>
        </div>
      </section>
    </main>
  );
};

export default TermsAndConditions;